"use client";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

/* PACKAGES */
import PhoneInput from "react-phone-number-input";
import * as yup from "yup";
import { toast } from "sonner";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* FORM HANDLER */
import { useFormik } from "formik";

/* APIs */
import { postContactUsApi } from "service/api/contact.api";

const validationSchemaForContactUs = yup.object().shape({
  firstName: yup.string().required("First Name is required."),
  email: yup.string().required("Email is required."),
  phoneNumber: yup.string().required("Phone Number is required."),
  lastName: yup.string().required("Last Name is required."),
});

const LandingPageForm = () => {
  const navigate = useNavigate();

  /* STATE VARIABLES */
  const [loading, setLoading] = useState(false);

  /* FORM HANDLER */
  const formHandling = useFormik({
    initialValues: {
      firstName: "",
      email: "",
      phoneNumber: "",
      lastName: "",
    },
    validationSchema: validationSchemaForContactUs,
    onSubmit: (values) => {
      setLoading(true);
      postContactUsApi(values)
        .then((res) => {
          if (res?.status) {
            navigate("/thank-you");
            formHandling.handleReset();
          } else {
            toast.error(res.message);
          }
        })
        .catch((e) => {
          if (e?.message === "Network Error") {
            toast.error(e?.message);
          } else {
            console.log("ERROR", e?.response?.data?.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <form className="mt-5" onSubmit={formHandling.handleSubmit}>
      <div className="grid grid-cols-2 gap-5">
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-greyText">
            First name <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="firstName"
              id="firstName"
              placeholder="First name"
              className={`w-full block bg-white focus:outline-logo border ${
                formHandling.errors.firstName && formHandling.touched.firstName
                  ? "border-red-400"
                  : "border-greyBorder"
              }  rounded-lg px-5 py-2.5 text-sm font-source font-normal`}
              value={formHandling.values.firstName}
              onChange={formHandling.handleChange}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-greyText">
            Last name <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="text"
              name="lastName"
              id="lastName"
              placeholder="Last name"
              className={`w-full block bg-white focus:outline-logo border ${
                formHandling.errors.lastName && formHandling.touched.lastName
                  ? "border-red-400"
                  : "border-greyBorder"
              } rounded-lg px-5 py-2.5 text-sm font-source font-normal`}
              value={formHandling.values.lastName}
              onChange={formHandling.handleChange}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-greyText">
            Email address <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email address"
              className={`w-full block bg-white focus:outline-logo border ${
                formHandling.errors.email && formHandling.touched.email
                  ? "border-red-400"
                  : "border-greyBorder"
              } rounded-lg px-5 py-2.5 text-sm font-source font-normal`}
              value={formHandling.values.email}
              onChange={formHandling.handleChange}
            />
          </div>
        </div>
        <div className="col-span-2 xl:col-span-1 lg:col-span-1">
          <label className="text-sm font-source font-normal text-greyText">
            Phone <span className="text-red-400">*</span>
          </label>
          <div className="mt-1">
            <PhoneInput
              defaultCountry="US"
              className={
                formHandling.errors.phoneNumber &&
                formHandling.touched.phoneNumber
                  ? "phone-input-error"
                  : "phone-input"
              }
              name="phoneNumber"
              placeholder="Phone"
              value={formHandling.values.phoneNumber}
              onChange={(e) => {
                formHandling.setFieldValue("phoneNumber", e);
              }}
            />
          </div>
        </div>
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="shadow-none hover:shadow-none mt-5 bg-primary hover:bg-opacity-70 transition-all duration-300 ease-in-out rounded-md px-7 py-3 normal-case font-source font-semibold text-white text-sm"
      >
        {loading ? "Please wait..." : "Submit"}
      </Button>
    </form>
  );
};

export default LandingPageForm;
